/* FORGE colorway siblings — size-aware states + the sold-out rescue line.
   Listens for the 'forge:variant-change' event that forge-pdp.js dispatches whenever the
   shopper picks a size, then:
     - marks each colorway tile "M in stock" / "M sold out" for the SELECTED size
     - deep-links each tile to that colorway's matching variant (?variant=) when it exists
     - when the current selection is sold out, fills the rescue line above the ATC with
       only the colorways that actually have that size in stock
   Degrades to plain product links with no size selected or no sibling data. */
(function () {
  'use strict';

  var row = document.querySelector('[data-forge-siblings]');
  var rescue = document.querySelector('[data-forge-rescue]');
  if (!row && !rescue) { return; }

  function norm(v) {
    return String(v || '').toLowerCase().replace(/[\s().\-"/]/g, '');
  }

  /* Fallback only. The authoritative short code arrives on the event as `sizeShort`,
     rendered by the forge-size-short snippet, so the tile marker and the chip always
     agree. This mirrors step 1-2 of that snippet for the no-event case. */
  function shortSize(v) {
    return String(v || '').split('(')[0].split('|')[0].trim();
  }

  function parseSizes(el) {
    var map = {};
    var raw = el.getAttribute('data-sizes') || '';
    raw.split(',').forEach(function (chunk) {
      var parts = chunk.split(':');
      if (parts.length < 3 || !parts[0]) { return; }
      map[parts[0]] = { available: parts[1] === '1', id: parts[2] };
    });
    return map;
  }

  var tiles = row ? Array.prototype.slice.call(row.querySelectorAll('[data-forge-sibling]')) : [];
  tiles.forEach(function (t) { t._sizes = parseSizes(t); });

  /* AVAILABILITY COMMUNICATES THROUGH STATE, NOT REPEATED TEXT.
     Brandon, 2026-08-14: every one of the 8 tiles repeated "XXX-Small in stock" in ember,
     wrapping to 2-3 lines each — the same sentence eight times, 328px of page.
     The rule now:
       - tile that HAS the selected size in stock -> renders normally, NO text
       - tile that does NOT -> dimmed, plus a small "no 3XS" marker (that is the only
         case where a word is worth its space, because the tile is otherwise just dim)
     The one sentence that states the situation in prose still exists — once — in the
     rescue line above the ATC, which is where it belongs. */
  function update(detail) {
    var sizeValue = detail && detail.sizeValue;
    var currentAvailable = !detail || detail.available !== false;
    var key = norm(sizeValue);
    var label = (detail && detail.sizeShort) || shortSize(sizeValue);
    var withStock = [];

    tiles.forEach(function (t) {
      var stockEl = t.querySelector('[data-forge-sibling-stock]');
      var base = t.getAttribute('data-base-url');
      if (!key) {
        t.href = base;
        t.classList.remove('size-out', 'size-in');
        if (stockEl) { stockEl.hidden = true; stockEl.textContent = ''; }
        return;
      }
      var hit = t._sizes[key];
      if (hit && hit.available) {
        t.href = base + '?variant=' + hit.id;
        t.classList.add('size-in');
        t.classList.remove('size-out');
        /* in stock in this size: silence. The normal (undimmed) tile IS the message. */
        if (stockEl) { stockEl.hidden = true; stockEl.textContent = ''; }
        if (t.getAttribute('aria-current') !== 'true') { withStock.push(t); }
      } else {
        t.href = base;
        t.classList.add('size-out');
        t.classList.remove('size-in');
        if (stockEl) { stockEl.hidden = false; stockEl.textContent = 'no ' + label; }
        /* the dimming is visual; screen readers get it in words on the link itself */
        t.setAttribute('aria-description', 'Not available in ' + (sizeValue || label));
      }
      if (hit && hit.available) { t.removeAttribute('aria-description'); }
    });

    if (!rescue) { return; }
    if (currentAvailable || !key) {
      rescue.hidden = true;
      rescue.innerHTML = '';
      return;
    }
    /* current selection is sold out — offer only colorways that really have this size */
    if (!withStock.length) {
      rescue.hidden = false;
      rescue.innerHTML = '<p class="forge-rescue-line">Sold out in ' + label +
        '. No other colorway has this size right now, so use the notify option below.</p>';
      return;
    }
    var html = '<p class="forge-rescue-line">Sold out in ' + label + '. Available in:</p>' +
      '<div class="forge-rescue-tiles"></div>';
    rescue.hidden = false;
    rescue.innerHTML = html;
    var holder = rescue.querySelector('.forge-rescue-tiles');
    withStock.forEach(function (t) {
      var a = document.createElement('a');
      a.className = 'forge-rescue-tile';
      a.href = t.href;
      var img = t.querySelector('img');
      if (img) {
        var c = document.createElement('img');
        c.src = img.currentSrc || img.src;
        c.alt = '';
        c.loading = 'lazy';
        a.appendChild(c);
      }
      var span = document.createElement('span');
      span.textContent = t.getAttribute('data-label');
      a.appendChild(span);
      holder.appendChild(a);
    });
  }

  document.addEventListener('forge:variant-change', function (e) { update(e.detail); });

  /* initial paint from the server-rendered selection */
  var initial = document.querySelector('[data-forge-initial-selection]');
  if (initial) {
    update({
      sizeValue: initial.getAttribute('data-size-value'),
      sizeShort: initial.getAttribute('data-size-short'),
      available: initial.getAttribute('data-available') === 'true'
    });
  }
})();
